export default "__VITE_ASSET__CR2h7gQV__"